
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RepairGrid extends Serenity.EntityGrid<RepairRow, any> {
        protected getColumnsKey() { return 'Inventory.Repair'; }
        protected getDialogType() { return RepairDialog; }
        protected getIdProperty() { return RepairRow.idProperty; }
        protected getInsertPermission() { return RepairRow.insertPermission; }
        protected getLocalTextPrefix() { return RepairRow.localTextPrefix; }
        protected getService() { return RepairService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            
            var voucherNo = FormatHelper.GetVoucherNo(97);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[97].AutoPosting;

            this.editItem(<RepairRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 97,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: new Date().toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
          //  this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}